/**
 * @module app.um
 */

import * as UM from 'app/um/models/essette-api';
import { SortChangeEvent } from 'app/shared/attributes/sortable-attribute';
import { apiCall } from 'app/shared/lib/api/api';
import { IQueryLoadOptions } from 'app/shared/lib/api/api-types';
import { ComponentBase, SortDirection, Sorting } from 'app/shared/lib/essette-site';
import { AuthService } from 'app/um/services/auth-service';
import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { EssPagerCustomElement } from 'app/shared/elements/ess-pager';


@autoinject()
export class AuthAssignmentHistoryGrid extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.objectNull({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload' })
    public auth: UM.Auth | null = null;

    @bindable({ defaultBindingMode: bindingMode.toView })
    protected pageSize: number | undefined = 10;

    private sorting: Sorting = new Sorting();
    protected resultCount: number | null = 0;

    ////****************** Element References ***************************************////
    protected $pager: EssPagerCustomElement | any;


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly authService: AuthService,
        ...rest: any[]) {

        super(...rest);
    }

    protected bind(bindingContext: Object, overrideContext: Object): void {
        if(!this.auth?.id) {
            return;
        }

        this.reload();

    }


    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////
    protected applySort(event: SortChangeEvent): void {
        const { property, direction } = event.detail;
        const { sorting: sorting } = this;
        if(direction === null) {
            sorting.remove(property);
        } else {
            sorting.add({
                reference: property,
                direction: direction === 'asc' ? SortDirection.Ascending : SortDirection.Descending
            });
        }
        this.reload();
    }

    public async reload(): Promise<void> {
        if(!this.auth) { return; }

        const [assignments] = await Promise.all([
            this.loadAuthAssignmentHistory()
        ]);

        this.auth.history = Object.assign(this.auth.history || {}, { assignments });
    }



    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadAuthAssignmentHistory(): Promise<UM.AuthAssignmentHistory[]> {
        if(!this.auth?.id) { return []; }

        const options: Partial<IQueryLoadOptions> = {
            top: this.pageSize,
            page: this.$pager?.page || 0,
            sorting: this.sorting
        };

        const includes = [
            'user',
            'metadata.started.byUser'
        ];

        try {
            this.state.beginLoad();

            const response = await this.authService.loadAssignmentHistoryByAuth(this.auth.id, options, includes);
            var r = response.results;
            this.resultCount = response.count || 0;
            return r;
        }
        catch(error) {
            throw error;
        }
        finally {
            this.state.endLoad();
        }
    }
}
